export const PublishNavbar = {
  hide: (el) => !el.hasProjectPermission('editMode'),
  state: {
    modes: {
      publish: {
        icon: 'sf upload',
        text: '{{ publish.action.publish | polyglot }}',
        callback: async (el) => {
          await el.call('openRouterModal', '/publish')
        }
      },
      sync: {
        icon: 'syncOvalFill',
        text: '{{ publish.action.sync | polyglot }}',
        callback: async (el) => {
          await el.call('openRouterModal', '/publish')
        }
      },
      export: {
        icon: 'sf download',
        text: '{{ publish.action.export | polyglot }}',
        callback: async (el) => {
          await el.call('openRouterModal', '/publish')
        }
      }
    },
    activeOutput: 'publish'
  },
  Button: {
    icon: (el, s) => s.modes[s.activeOutput].icon,
    text: null,
    title: (el) => el.call('polyglot', 'publish.action.publish'),
    aspectRatio: 'none',
    onClick: async (ev, el, s) => {
      await s.modes[s.activeOutput].callback(el)
    }
  },
  IconButton: {
    DropdownParentFocus: {
      position: 'absolute',
      Dropdown: {
        left: '-F',
        onClick: () => {},
        'Dropdown.Publish': {}
      },
      inset: '0'
    }
  },
  extends: 'DropdownButton'
}
